<app-menu></app-menu>
<div class="container-fluid mt-5">
    <div class="col-12">
        <div class="row d-none d-lg-block d-xl-block">
            <div class="col-6 text-left">
                <h3>
                    <img src="../../../assets/img/cuenta.png" width="50" class="img-fluid" alt="Responsive image"> Solicitudes de Compra:
                </h3>
            </div>
            <div class="col-6">
                <div class="form-group mt-3">
                    <select class="form-control sch" (click)="filtrar($event.target.value)">
                        <option value="" selected>Seleccione para búsqueda...</option>
                        <option value="pendientes">Pedidos Pendientes</option>
                        <option value="aceptados">Pedidos Aceptados</option>  
                        <option value="cancelados">Pedidos Cancelados</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
            <div class="col-12">
                <h3>
                    <img src="../../../assets/img/cuenta.png" width="50" class="img-fluid" alt="Responsive image"> Solicitudes de Compra:
                </h3>
            </div>
            <div class="col-12">
                <div class="form-group mt-3">
                    <select class="form-control sch" (click)="filtrar($event.target.value)">
                        <option value="" selected>Seleccione para búsqueda...</option>
                        <option value="pendientes">Pedidos Pendientes</option>
                        <option value="aceptados">Pedidos Aceptados</option>  
                        <option value="cancelados">Pedidos Cancelados</option>
                    </select>
                </div>
            </div>
        </div>
        <hr>
        <div class="col-12">
            <div class="table-responsive">
                <table class="table">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">Cliente</th>
                            <th scope="col">Fecha</th>
                            <th scope="col">Correo</th>
                            <th scope="col">Estado</th>
                            <th scope="col">Teléfono</th>
                            <th scope="col">Referencia</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of pendientes">
                            <td><b>{{item.nombre | titlecase}}</b></td>
                            <td>{{item.fecha | date}}</td>
                            <td>{{item.email}}</td>
                            <td>{{item.estado}}</td>
                            <td>{{item.telefono}}</td>
                            <td>{{item.refCompra}}</td>
                            <td>
                                <button title="Ver Detalle del Pedido" class="btn btn-warning" (click)="detalle(item)" data-toggle="modal" data-target="#pedidos"><i class="fa fa-list"></i></button>
                                <button title="Ver Detalle del Pedido" class="btn btn-danger ml-1" (click)="cancelarPedidoTabla(item.id)"><i class="fa fa-trash"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="pedidos" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Detalle de Pedido:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <h5>Tipo de pedido: <b>{{tipo}}</b></h5>
                <h5>Cliente: <b>{{comprador | titlecase}}</b></h5>
                <h5>Identificación: <b>C.C. {{cedula}}</b></h5>
                <h5>Teléfono: <b>{{telefono}}</b></h5>
                <h5>E-mail: <b>{{email}}</b></h5>
                <h5>Estado: <b>{{estado}}</b></h5>
                <h5>Ciudad Entrega: <b>{{ciudad | titlecase}}</b></h5>
                <h5>Dirección Entrega: <b>{{direccion}}</b></h5>
                <div class="table-responsive">
                    <table class="table">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col">Producto</th>
                                <th scope="col">Cantidad</th>
                                <th scope="col">Presentación</th>
                                <th scope="col">Tamaño</th>
                                <th scope="col">Color</th>
                                <th scope="col">Precio</th>
                                <th scope="col">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of carrito">
                                <td><b>{{item.nombre}}</b></td>
                                <td>{{item.cantidad}}</td>
                                <td>{{item.presentacion}}</td>
                                <td>{{item.tamano}}</td>
                                <td>{{item.color}}</td>
                                <td>${{item.precio | number}}</td>
                                <td>${{item.total | number}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 text-right">
                    <h5>Subtotal: <b>${{subtotal | number}}</b></h5>
                    <h5>Descuento: <b>${{descuento | number}}</b></h5>
                    <hr>
                    <h3>Total: <b style="color: blue;">${{total | number}}</b></h3>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" printSectionId="print-section" ngxPrint data-dismiss="modal"><img src="../../../assets/img/printing.png" alt=""></button>
                <button *ngIf="estado == 'En envio'" type="button" class="btn btn-dark" (click)="cancelarPedido()" data-dismiss="modal">Cancelar Pedido</button>
                <button *ngIf="estado != 'En envio'" type="button" class="btn btn-dark" (click)="aceptarPedido()" data-dismiss="modal">Aceptar Pedido</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>
<div style="width: 100%;display: none;" id="print-section">
    <div align='center'>
        <p>Su Pedido S.A.S</p>
    </div>
    <hr>
    <div>
        <table style="width: 100%;">
            <tbody>
                <tr>
                    <td>Tipo de pedido:</td>
                    <td><b>{{tipo}}</b></td>
                </tr>
                <tr>
                    <td>Cliente:</td>
                    <td><b>{{comprador | titlecase}}</b></td>
                </tr>
                <tr>
                    <td>Identificación:</td>
                    <td><b>{{cedula}}</b></td>
                </tr>
                <tr>
                    <td>Teléfono:</td>
                    <td><b>{{telefono}}</b></td>
                </tr>
                <tr>
                    <td>Correo Electrónico:</td>
                    <td><b>{{email}}</b></td>
                </tr>
                <tr>
                    <td>Estado del Pedido:</td>
                    <td><b>{{estado}}</b></td>
                </tr>
            </tbody>
        </table>
        <hr>
        <table border="1" style="width: 100%;border: 1px solid rgb(75, 74, 74);">
            <tbody>
                <tr>
                    <th>Producto</th>
                    <th>Cantidad</th>
                    <th>Presentación</th>
                    <th>Tamaño</th>
                    <th>Color</th>
                    <th>Precio</th>
                    <th>Total</th>
                </tr>
                <tr *ngFor="let item of carrito">
                    <td><b>{{item.nombre}}</b></td>
                    <td>{{item.cantidad}}</td>
                    <td>{{item.presentacion}}</td>
                    <td>{{item.tamano}}</td>
                    <td>{{item.color}}</td>
                    <td>${{item.precio | number}}</td>
                    <td>${{item.total | number}}</td>
                </tr>
            </tbody>
        </table>
        <div style="width: 100%;">
            <h3 style="float: right;"><b>TOTAL: ${{total | number}}</b></h3>
        </div>
    </div>
</div>